'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

PersonStatisticsViewModel=function(){
function PersonStatisticsViewModel(statistics,viewScheduleFunc){_classCallCheck(this,PersonStatisticsViewModel);
_.ensureInstanceOf('object',statistics);
_.ensureInstanceOf('function',viewScheduleFunc);

this._statistics=statistics;
this._viewSchedule=viewScheduleFunc;
this._groupMembershipsAtScope=[];
}_createClass(PersonStatisticsViewModel,[{key:'id',get:function()

{
return this._statistics.id;
}},{key:'firstName',get:function()

{
return this._statistics.firstName;
}},{key:'lastName',get:function()

{
return this._statistics.lastName;
}},{key:'name',get:function()

{
return`${this.lastName}, ${this.firstName}`;
}},{key:'employeeId',get:function()

{
return this._statistics.employeeId;
}},{key:'statistics',get:function()

{
return this._statistics;
}},{key:'groupMembershipsAtScope',get:function()

{

return this._groupMembershipsAtScope;
}},{key:'viewSchedule',get:function()

{
return this._viewSchedule;
}}]);return PersonStatisticsViewModel}();


module.exports=PersonStatisticsViewModel;
//# sourceMappingURL=personStatisticsViewModel.js.map
